// Types
import type { ComponentPropsWithoutRef } from 'react';
import Link from 'next/link';

import clsx from 'clsx';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// Hooks
import useMarketingUrl from '@/utils/urls/useMarketingUrl';

//components
import Button from '@/components/base/Button';

type ContactContentProps = ComponentPropsWithoutRef<'div'> &
    Pick<ContactContainerProps, 'withG2Review'> & {
        title: string;
        text: string;
    };

const ContactContent = ({ title, text, withG2Review, children }: ContactContentProps) => {
    return (
        <div
            className={clsx(
                'col-span-full flex flex-col rounded bg-white p-8 dark:bg-icoDarkMode-anthracite',
                { 'lg:col-span-3 xl:col-span-2': withG2Review, 'lg:col-span-3': !withG2Review }
            )}>
            <p className="font-GBold text-sm text-icoBlack dark:text-white" title={title}>
                {title}
            </p>
            <p className="mb-5 font-GMedium text-sm text-icoBlack dark:text-white" title={text}>
                {text}
            </p>
            {children}
        </div>
    );
};

type ContactContainerProps = {
    withG2Review?: boolean;
};
const ContactContainer = ({ withG2Review }: ContactContainerProps) => {
    const { t } = useTranslation('home');
    const { marketingUrl } = useMarketingUrl();

    return (
        <div
            className={clsx(
                'grid grid-cols-6 gap-5 rounded-md bg-white bg-opacity-40 p-5 dark:bg-icoDarkMode-deepBlack dark:bg-opacity-10',
                { 'mt-1': withG2Review, 'mt-10': !withG2Review }
            )}>
            <ContactContent
                title={t('contact.contact_1.title')}
                text={t('contact.contact_1.text')}
                withG2Review={withG2Review}>
                <div className="mt-auto flex space-x-2">
                    <Button
                        as={Link}
                        size="sm"
                        icon="help"
                        href={process.env.NEXT_PUBLIC_BASE_FAQ_URL}
                        target="_blank">
                        {t('contact.contact_1.button_1')}
                    </Button>
                    <Button
                        as={Link}
                        size="sm"
                        icon="envelope"
                        href={marketingUrl('contact')}
                        target="_blank">
                        {t('contact.contact_1.button_2')}
                    </Button>
                </div>
            </ContactContent>
            <ContactContent
                title={t('contact.contact_2.title')}
                text={t('contact.contact_2.text')}
                withG2Review={withG2Review}>
                <div className="mt-auto flex">
                    <Button
                        icon="help"
                        as={Link}
                        size="sm"
                        href={marketingUrl('book_a_demo')}
                        target="_blank">
                        {t('contact.contact_2.button')}
                    </Button>
                </div>
            </ContactContent>
        </div>
    );
};

export default ContactContainer;
